module.exports = __webpack_public_path__ + "static/img/call_icon.94a8f6f7.png";